<template>
    <div class="container-top mt-5" :class="{ 'container-wide': lgAndUp || xlAndUp }">
      <router-view></router-view>

    </div>
</template>

<script>
import { ref, inject } from "vue";
import { useRoute } from 'vue-router';
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
export default {
  setup() {
    const primarycolor = inject('primarycolor')
    const route = useRoute();
    const menuShouldShow = ref(false);
    const { xsOnly, smAndUp, mdAndUp, lgAndUp, xlAndUp } = deviceBreakpoint()
    const toggleMenu = ()=>{
           menuShouldShow.value = !menuShouldShow.value
         };

    return {
      menuShouldShow,
      route,
      toggleMenu,
      lgAndUp,
      xlAndUp,
      mdAndUp,
      xsOnly,
      smAndUp,
      primarycolor
    }
  }
};
</script>
